const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const apiBase = trimTrailingSlash(import.meta.env.VITE_API_BASE_URL ?? "");
const websocketBase = trimTrailingSlash(import.meta.env.VITE_WS_BASE_URL ?? "");

export const apiUrl = (path: string) =>
  `${apiBase}${path.startsWith("/") ? path : `/${path}`}`;

export const websocketUrl = (path: string) => {
  if (websocketBase) {
    return `${websocketBase}${path.startsWith("/") ? path : `/${path}`}`;
  }
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}${path.startsWith("/") ? path : `/${path}`}`;
};

export async function responseError(
  response: Response,
  fallback: string
): Promise<Error> {
  try {
    const body = (await response.json()) as {
      error?: { message?: string; requestId?: string };
    };
    const suffix = body.error?.requestId ? ` Request ${body.error.requestId}.` : "";
    return new Error(`${body.error?.message ?? fallback}${suffix}`);
  } catch {
    return new Error(fallback);
  }
}
